<template>
  <div class="the-logo">
      <div class="custom-logo" :style="{backgroundImage: `url(${publicPath}custom-logo.png)`}">
      </div>
		  <span class="the-logo__title">{{$t('common.profetAI')}}</span> 
  </div>
</template>
<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    }; 
  }, // End of data

} // End of export
</script>
<style lang="scss" scoped>
  .the-logo {
    height: 25px;
    display: flex;
    &__img {
      display: none;
      @media screen and (min-width: 414px){
        display: block;
      }
    }
    &__title {
      color:#fff;
      background: #1BB5AC;
      border-radius: 20px;
      padding: 5px;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: 15px;
      display: inline-block;
      max-width: 45%;
    }

    .custom-logo{
      width: 155px;
      background-size: cover;  
      background-position: center center;   
    }
  }

</style>